{
  "tableConfig": {
    "columns": [
      {
        "fieldName": "receiptNo",
        "displayName": "Receipt No",
        "dataType": "STRING",
        "sortable": false
      },
      {
        "fieldName": "payingParty.name",
        "displayName": "Paying Name",
        "dataType": "STRING",
        "sortable": false
      },
      {
        "fieldName": "invoiceNoList",
        "displayName": "Invoice No",
        "dataType": "STRING"
      },
      {
        "fieldName": "totalAmount",
        "displayName": "Amount",
        "dataType": "STRING"
      },
      {
        "fieldName": "paymentDate",
        "displayName": "Payment Date",
        "dataType": "DATETIME",
        "sortable": true
      },
      {
        "fieldName": "createdBy",
        "dbName": "created_by",
        "displayName": "Created By",
        "dataType": "STRING",
        "styleConfig": {
          "type": "user-avatar"
        }
      },
      {
        "fieldName": "createdDate",
        "dbName": "created_date",
        "displayName": "Created Date",
        "dataType": "DATETIME",
        "sortable": true
      }
    ]
  },
  "filterConfig": {
    "filterFields": [
      {
        "name": "customerName",
        "displayLabel": "Customer",
        "dataType": "STRING",
        "operatorToFilterMap": {
          "EQ": "CUSTOMER_NAME_EQUALS"
        }
      },
      {
        "name": "invoiceNo",
        "displayLabel": "Invoice No",
        "dataType": "STRING",
        "operatorToFilterMap": {
          "EQ": "INVOICE_NO_EQUALS"
        }
      }
    ],
    "useNewContract": true
  },
  "searchBarConfig": {
    "placeHolder": "Search by receipt no or customer name",
    "filters": [
      {
        "name": "RECEIPT_NO_CONTAINS",
        "alias": "Receipt_No"
      },
      {
        "name": "CUSTOMER_NAME_CONTAINS",
        "alias": "Customer_Name"
      },
      {
        "name": "INVOICE_NO_CONTAINS",
        "alias": "Invoice_No"
      }
    ]
  }
}
